<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        title="Periode kiezen"
        :small="true"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <dean-form-row id="startDate" label="startdatum" type="date" v-model="dates.startDate" :warning="$v.dates.startDate.$error" @focus="$v.dates.startDate.$touch()" :required-field="true"></dean-form-row>
      <dean-form-row id="endDate" label="einddatum" type="date" v-model="dates.endDate" :warning="$v.dates.endDate.$error" @focus="$v.dates.endDate.$touch()" :required-field="true"></dean-form-row>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="send()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanDialogButtonGroup,
      deanFormRow,
    },
    mixins: [validationMixin],
  })

  export default class PricePlanPeriodDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public dates: any = {
      startDate: null,
      endDate: null,
    };
    public url: string = '';
    public urlParams: any = {};

    // COMPUTED
    @Validations()
    get validations() {
      return {
        dates: {
          startDate: {required},
          endDate: {required},
        },
      };
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public send() {
      this.$v.$touch();

      if (this.payloadData.view === 'period' && this.payloadData.action === 'add') {
        this.sendPeriodAdd();
      } else if (this.payloadData.view === 'period' && this.payloadData.action === 'edit') {
        this.sendPeriodEdit();
      } else if (this.payloadData.view === 'entry') {
        this.sendEntryAdd();
      }
    }

    public sendPeriodAdd() {
      if (! this.$v.$invalid) {
        this.$emit('setLoad', true);

        this.routeAfterSend();

        this.close();

        this.$emit('setLoad', false);
      }
    }

    public sendPeriodEdit() {
      const requestAction = 'processPricePlanPeriodUpdate';

      const pricePlanPeriodSaveRequestMapper = {
        pricePlanId: this.payloadData.contextId,
        startDate: this.payloadData.oldStartDate,
        endDate: this.payloadData.oldEndDate,
        newStartDate: this.dates.startDate,
        newEndDate: this.dates.endDate,
      };

      if (! this.$v.$invalid) {
        this.$emit('setLoad', true);

        this.$store.dispatch(requestAction, pricePlanPeriodSaveRequestMapper)
          .then(
            (response: any) => {
              this.routeAfterSend();

              this.close();
            },
            (error: any) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            },
          )
          .finally(() => {
            this.$emit('setLoad', false);
          });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public sendEntryAdd() {
      if (! this.$v.$invalid) {
        this.$emit('setLoad', true);

        this.$router.push({name: 'standingData.pricePlan.entries.add', params: this.dates});

        this.close();

        this.$emit('setLoad', false);
      }
    }

    public created() {
      //
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }

    private routeAfterSend() {
      this.$router.push({name: 'standingData.pricePlan.entries.filter', params: this.dates});
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

</style>
